import React from 'react';
import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';

const DlpRulesExchange = () => {
  return (
    <DlpRules
      applyBoundShow={false}
      scanTargetShow={false}
      complianceRuleNoteShow={false}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={true}
      mipShow={false}
    />
  );
};
export default DlpRulesExchange;
